import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import { moneyValueGetterFactory } from "../../../records/grids/cells/valueGetters";
import {
  ColumnDefinitionSetServiceProvider,
  vsProviderName as ColumnDefinitionSetServiceProviderName,
  vsServiceName as ColumnDefinitionSetServiceName,
} from "../../../records/grids/columns/columnDefinitionSetService";
import {
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../../records/views/recordGridView";
import { RecordDataSource } from "../../../records/grids";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";

import {
  FormViewService,
  FormViewServiceProvider,
  vsProviderName as FormViewServiceProviderName,
  vsServiceName as FormViewServiceName,
} from "../../../records/forms/formView";
import { getProjectColumnDefs } from "../../shared/configs/project";


export const projectCostConfigViewDefaultSort =
  "Id";

projectCostConfig.$inject = [
  RecordGridViewServiceProviderName,
  ColumnDefinitionSetServiceProviderName,
  FormViewServiceProviderName,
];

export const vsObjectName = "projectCost";
export function projectCostConfig(
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider,
  formViewServiceProvider: FormViewServiceProvider
) {
  registerGrid(
    recordGridViewServiceProvider,
    columnDefinitionSetServiceProvider
  );
  
}


function registerGrid(
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider
) {
  
  columnDefinitionSetServiceProvider.addColumnDefinitionSet(
    vsObjectName,
    [
      ColumnDefinitionServiceName,
      ColumnDefinitionSetServiceName,
      
      (
        columnDefinitionService: ColumnDefinitionService,
        
      ) => [
        
          columnDefinitionService.getNumberColDef({
            field: "Id",
            hide: true,
          }),
          
          columnDefinitionService.getStringColDef({
            header: "Cost Type",
            field: "ProjectCostTypeName",
          }),
          columnDefinitionService.getStringColDef({
            header: "Cost Category",
            field: "ProjectCostCategoryName",
          }),
          columnDefinitionService.getNumberColDef({
            field: "Hours",
          }),
          columnDefinitionService.getNumberColDef({
            field: "Rate",
            valueGetter: moneyValueGetterFactory(),
          }),
          columnDefinitionService.getNumberColDef({
            field: "Total",
            valueGetter: moneyValueGetterFactory(),
          }),
          ...getProjectColumnDefs(columnDefinitionService)
        ],
    ]);

  recordGridViewServiceProvider.addGridConfiguration(
    vsObjectName,
    [
      ServerUtilityName,
      GridSettingsServiceName,
      (
        serverUtility: ServerUtility,
        gridSettingsService: GridSettingsService
      ) => {
        return {
          columnDefinitionSet: vsObjectName,
          defaultSort: projectCostConfigViewDefaultSort,
          gridDataSource: new RecordDataSource(
            serverUtility,
            "/api/project/ProjectCost"
          ),
          gridSettings: gridSettingsService.getGridSettings(
            Symbol(vsObjectName)
          ),
          nameSingular: "Project Cost",
          namePlural: "Projects Cost",
          showAddButton: false,
          showAddButtonPermission: "projectCostEdit",
        };
      },
    ]
  );

}
